const ww = window.innerWidth
const wh = window.innerHeight

const s3BgW = wh * 2600 / 2436
const s3DoorX = 470 * s3BgW / 2600
const s3DoorW = wh * 0.511 * 704 / 1244
const s3BookcaseX = s3DoorX + s3DoorW + 250 / 2600 * s3BgW
const s3LightX = s3DoorX + s3DoorW + 710 / 2600 * s3BgW
const s3ClockX = s3DoorX + s3DoorW + 1034 / 2600 * s3BgW
const s3CalenderX = s3DoorX + s3DoorW + 1040 / 2600 * s3BgW
const s3ChildX = s3DoorX + s3DoorW - 270 / 2600 * s3BgW
const s3MotherX = s3DoorX + s3DoorW * 0.5
const s3MotherH = 0.48
const s3MotherY = 0.88 - s3MotherH / 2

const s3ClockW = wh * 0.1 * 247 / 243
const s3ClockY = 0.243 * wh
const s3ClockC = s3ClockY + wh * 0.1 / 2
const s3HourX = s3ClockX + s3ClockW / 2
const s3MinuteX = s3ClockX + s3ClockW / 2

const sprites = {
  s3_bg: {
    size: { mode: 'heightFit', height: 1 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s3_door: {
    size: { mode: 'heightFit', height: 0.511 },
    position: { x: s3DoorX / ww, y: 0.867 },
    anchor: 'bottomLeft'
  },
  s3_bookcase: {
    size: { mode: 'heightFit', height: 0.572 },
    position: { x: s3BookcaseX / ww, y: 0.782 },
    anchor: 'bottomLeft'
  },
  s3_light: {
    size: { mode: 'heightFit', height: 0.266 },
    position: { x: s3LightX / ww, y: 0 },
    anchor: 'topLeft'
  },
  s3_calender: {
    size: { mode: 'heightFit', height: 0.133 },
    position: { x: s3CalenderX / ww, y: 0.392 },
    anchor: 'topLeft'
  },
  s3_clock: {
    size: { mode: 'heightFit', height: 0.1 },
    position: { x: s3ClockX / ww, y: 0.243 },
    anchor: 'topLeft'
  },
  s3_minute: {
    size: { mode: 'heightFit', height: 0.028 },
    position: { x: s3MinuteX / ww, y: s3ClockC / wh },
    anchor: { x: 0.5, y: 0.9 }
  },
  s3_hour: {
    size: { mode: 'heightFit', height: 0.007 },
    position: { x: s3HourX / ww, y: s3ClockC / wh },
    anchor: { x: 0.9, y: 0.5 }
  },
  s3_mother: {
    key: 's3_mother1',
    size: { mode: 'heightFit', height: s3MotherH },
    position: { x: s3MotherX / ww, y: s3MotherY },
    anchor: 'center'
  },
  s3_child: {
    size: { mode: 'heightFit', height: 0.406 },
    position: { x: s3ChildX / ww, y: 1 },
    anchor: 'bottomLeft'
  },
  s3_textnew: {
    size: { mode: 'heightFit', height: 794 / 2436 },
    position: { x: 120 / 1125, y: 100 / 2436 },
    anchor: 'topLeft'
  },
  s3_talk1: {
    size: { mode: 'heightFit', height: 0.325 },
    position: { x: 0.4, y: 0.48 },
    anchor: 'bottomLeft'
  },
  s3_talk2: {
    size: { mode: 'heightFit', height: 0.377 },
    position: { x: 0.72, y: 0.6 },
    anchor: 'bottomRight'
  }
}

export default sprites



// WEBPACK FOOTER //
// ./src/assets/scenes/s3/sprites.js